"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TemplatesOverviewContainer = exports.getTemplates = exports.getTemplateButtons = exports.getTemplateBadges = exports.getCategoryList = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const AppContext_1 = require("../AppContext");
const TemplateOverview_1 = require("./TemplateOverview");
function getCategoryList(campaign, templates, selectedCategoryId, setSelectedCategoryId) {
    if (campaign.data.length === 1)
        return [];
    const categories = campaign.data
        .filter((category) => templates.find((template) => template.format === category.id))
        .map((item) => ({
        label: item.name,
        variant: templates.length > 0
            ? selectedCategoryId === item.id
                ? 'active'
                : 'default'
            : 'disabled',
        onClick: () => setSelectedCategoryId(item.id),
    }));
    const defaultCategories = [
        {
            label: 'All',
            variant: templates.length > 0
                ? selectedCategoryId
                    ? 'default'
                    : 'active'
                : 'disabled',
            onClick: () => setSelectedCategoryId(null),
        },
    ];
    return categories.length > 1
        ? defaultCategories.concat(categories)
        : defaultCategories;
}
exports.getCategoryList = getCategoryList;
function getTemplateBadges(template) {
    const pagesLength = template.pages.length;
    const badges = [];
    if (template.is_premium)
        badges.push({
            name: `crown---gold`,
            size: 'Medium',
            position: 'bottom-right',
            label: 'Pro+',
        });
    if (pagesLength > 1)
        badges.push({
            name: `pages---${pagesLength > 9 ? `9-plus` : pagesLength}`,
            size: 'Medium',
        });
    return badges;
}
exports.getTemplateBadges = getTemplateBadges;
function getTemplateButtons(template) {
    return [];
}
exports.getTemplateButtons = getTemplateButtons;
function getTemplates(templates, selectedCategoryId, onTemplateClick) {
    if (!templates)
        return [];
    const templateList = (selectedCategoryId
        ? templates.filter((item) => item.format === selectedCategoryId)
        : templates).filter((item) => { var _a; return ((_a = item.pages) === null || _a === void 0 ? void 0 : _a.length) > 0; });
    return templateList.map((item) => ({
        tile: {
            imageUrl: item.pages[0].thumbnail,
            size: 'full',
            onClick: () => onTemplateClick === null || onTemplateClick === void 0 ? void 0 : onTemplateClick({
                isPremium: item.is_premium,
                pageId: item.pages[0].id,
                pageNumber: 1,
                projectId: item.encoded_id,
            }),
        },
        subTitle: 'Page set',
        tiles: item.pages.map((page, index) => ({
            imageUrl: page.thumbnail,
            size: 'full',
            onClick: () => onTemplateClick === null || onTemplateClick === void 0 ? void 0 : onTemplateClick({
                isPremium: item.is_premium,
                pageId: page.id,
                pageNumber: index + 1,
                projectId: item.encoded_id,
            }),
        })),
        badges: getTemplateBadges(item),
        buttons: getTemplateButtons(item),
    }));
}
exports.getTemplates = getTemplates;
function TemplatesOverviewContainer() {
    var _a, _b;
    const { id, project, navigateTo, onTemplateClick } = (0, react_1.useContext)(AppContext_1.AppContext);
    const [selectedCategoryId, setSelectedCategoryId] = (0, react_1.useState)(null);
    const collection = project.campaigns.find((item) => String(item.id) === id);
    const collectionTemplates = (_a = project === null || project === void 0 ? void 0 : project.templates) === null || _a === void 0 ? void 0 : _a[id];
    const categories = (0, react_1.useMemo)(() => collection && Array.isArray(collection === null || collection === void 0 ? void 0 : collection.data)
        ? getCategoryList(collection, collectionTemplates !== null && collectionTemplates !== void 0 ? collectionTemplates : [], selectedCategoryId, setSelectedCategoryId)
        : [], [collection, selectedCategoryId, collectionTemplates]);
    const templates = (0, react_1.useMemo)(() => getTemplates(collectionTemplates !== null && collectionTemplates !== void 0 ? collectionTemplates : [], selectedCategoryId, onTemplateClick), [collectionTemplates, selectedCategoryId]);
    if (!id)
        return null;
    return ((0, jsx_runtime_1.jsx)(TemplateOverview_1.TemplateOverview, { label: 'Search for templates', backButtonLabel: 'Collections', collectionName: (_b = collection === null || collection === void 0 ? void 0 : collection.name) !== null && _b !== void 0 ? _b : 'Templates', templates: templates.slice(0, 20), categories: categories, onBackButtonClick: () => navigateTo === null || navigateTo === void 0 ? void 0 : navigateTo({ fragment: 'collections' }) }));
}
exports.TemplatesOverviewContainer = TemplatesOverviewContainer;
//# sourceMappingURL=TemplateOverviewContainer.js.map